import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URI}/api/projects`
});

export const getProjects = async (search = "", assignedTo = null) => {
  const response = await API.get("/", {
    params: {
      search,
      assigned_to: assignedTo
    }
  });

  return response.data;
};

export const getProject = async (projectId) => {
  const response = await API.get(`/${projectId}`);
  return response.data;
};

const normalizeAssignees = (assigned_to) => {
  if (!Array.isArray(assigned_to)) return [];
  return assigned_to.map((a) =>
    typeof a === "object" ? a : { employee_id: a, capacity_percent: 0 }
  );
};

export const createProject = async (data) => {
  const payload = { ...data, assigned_to: normalizeAssignees(data.assigned_to) };
  const response = await API.post("/", payload);
  return response.data;
};

export const updateProject = async (projectId, data) => {
  const payload = { ...data, assigned_to: normalizeAssignees(data.assigned_to) };
  const response = await API.put(`/${projectId}`, payload);
  return response.data;
};

export const deleteProject = async (projectId) => {
  const response = await API.delete(`/${projectId}`);
  return response.data;
};

export const getEmployeeCapacity = async (
  employeeId,
  excludeProjectId = null,
  startDate = null,
  endDate = null
) => {
  const response = await API.get(`/capacity/${employeeId}`, {
    params: {
      exclude_project_id: excludeProjectId,
      start_date: startDate,
      end_date: endDate
    }
  });

  return response.data;
};

// { [employee_id]: { total_capacity_percent, project_count } } for every
// employee with at least one project assignment.
export const getCapacitySummary = async () => {
  const response = await API.get("/capacity-summary");
  return response.data;
};

export default API;
